import { Link } from 'react-router-dom';
import Collapse from '@mui/material/Collapse';
import { useState } from "react";
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

const headerImage: React.CSSProperties = {
    height: '40vh',
    backgroundImage: "url('./images/soulfood.jpg')",
    padding: '0',
};

const SoulFoodPage: React.FC = () => {
    const [expanded, setExpanded] = useState<boolean>(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <>
            <Box className="site-cover site-cover-sm same-height overlay single-page" style={headerImage}>
            <Skeleton variant="rectangular" width="100%" height="100%" id="header-skeleton" />
            <div
                style={{ ...headerImage, display: 'none' }}
                onLoad={() => {
                document.getElementById('header-skeleton')!.style.display = 'none';
                (document.querySelector('.site-cover') as HTMLElement).style.display = 'block';
                }}
            />
            </Box>
            <section className="section">
                <div className="container">
                    <div className="row blog-entries element-animate">
                        <div className="col-md-12 col-lg-12 main-content">
                            <div className="post-content-body">
                                <br />
                                <h1>Soul Food (Hrana za dušu)</h1>
                                <h5>Veganski i vegetarijanski restoran u centru Zagreba</h5>
                                <hr/>
                                <br />
                                <p>Ako želite iskusiti raznolikost vegetarijanske hrane, Soul Food u Amruševoj 8 bit će za Vas jedno predivno iskustvo!</p>
                                <p>U ponudi svakoga dana imamo vegansku opciju jelovnika, a ponekad i lakto vegetarijansku (mliječni proizvodi).
                                Pripremamo kolače po Vašem izboru za proslave, rođendane i druge događaje.</p>
                                <p>Rezervacije i narudžbe molimo na broj <b>092 407 3691</b> do <b>10:00</b> sati ili na e-mail adresu <b>soulfoodbyc@gmail.com</b></p>
                                <p>Prilikom narudžbe dostave navedite adresu dostave i ime kome dostavljamo.</p>
                                <p>Tjedne jelovnike možete pratiti na našoj <a href="https://www.facebook.com/SoulFoodHr" target="_blank">FaceBook</a> stranici</p>
                                <br/>
                                <link href="https://awards.infcdn.net/2024/badge-circledLeaves27.css" rel="stylesheet"/><a id="b-circledLeaves27" target="_blank" href="https://restaurantguru.com/Soul-food-Hrana-za-dusu-klupski-zdravljak-Zagreb-2" className="b-circledLeaves27--light b-circledLeaves27--2025"> <span className="b-circledLeaves27__title">Recommended</span> <span className="b-circledLeaves27__separator"></span> <span className="b-circledLeaves27__name">Soul food-Hrana za dušu-klupski zdravljak Zagreb</span></a>
                                <br/>
                                <hr/>
                                <br />
                                <br />
                                <div className="row my-4">
                                    <div className="col-md-12 mb-4">
                                        <Box position="relative">
                                            <Skeleton variant="rectangular" width="100%" height={200} />
                                            <img
                                                src="./images/soulfood/1.jpg"
                                                alt="Soul Food"
                                                className="img-fluid rounded"
                                                onLoad={(e) => {
                                                    e.currentTarget.style.display = 'block';
                                                    (e.currentTarget.previousElementSibling as HTMLElement)!.style.display = 'none';
                                                }}
                                                onError={(e) => {
                                                    e.currentTarget.style.display = 'none';
                                                    (e.currentTarget.previousElementSibling as HTMLElement).style.display = 'none';
                                                }}
                                                style={{ display: 'none' }}
                                            />
                                        </Box>
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <Box position="relative">
                                            <Skeleton variant="rectangular" width="100%" height={200} />
                                            <img
                                                src="./images/soulfood/2.jpg"
                                                alt="Soul Food"
                                                className="img-fluid rounded"
                                                onLoad={(e) => {
                                                    e.currentTarget.style.display = 'block';
                                                    (e.currentTarget.previousElementSibling as HTMLElement)!.style.display = 'none';
                                                }}
                                                onError={(e) => {
                                                    e.currentTarget.style.display = 'none';
                                                    (e.currentTarget.previousElementSibling as HTMLElement)!.style.display = 'none';
                                                }}
                                                style={{ display: 'none' }}
                                            />
                                        </Box>
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <Box position="relative">
                                            <Skeleton variant="rectangular" width="100%" height={200} />
                                            <img
                                                src="./images/soulfood/3.jpg"
                                                alt="Soul Food"
                                                className="img-fluid rounded"
                                                onLoad={(e) => {
                                                    e.currentTarget.style.display = 'block';
                                                    (e.currentTarget.previousElementSibling as HTMLElement)!.style.display = 'none';
                                                }}
                                                onError={(e) => {
                                                    e.currentTarget.style.display = 'none';
                                                    (e.currentTarget.previousElementSibling as HTMLElement)!.style.display = 'none';
                                                }}
                                                style={{ display: 'none' }}
                                            />
                                        </Box>
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <Box position="relative">
                                            <Skeleton variant="rectangular" width="100%" height={200} />
                                            <img
                                                src="./images/soulfood/4.jpg"
                                                alt="Soul Food"
                                                className="img-fluid rounded"
                                                onLoad={(e) => {
                                                    e.currentTarget.style.display = 'block';
                                                    (e.currentTarget.previousElementSibling as HTMLElement)!.style.display = 'none';
                                                }}
                                                onError={(e) => {
                                                    e.currentTarget.style.display = 'none';
                                                    (e.currentTarget.previousElementSibling as HTMLElement)!.style.display = 'none';
                                                }}
                                                style={{ display: 'none' }}
                                            />
                                        </Box>
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <Box position="relative">
                                            <Skeleton variant="rectangular" width="100%" height={200} />
                                            <img
                                                src="./images/soulfood/5.jpg"
                                                alt="Soul Food"
                                                className="img-fluid rounded"
                                                onLoad={(e) => {
                                                    e.currentTarget.style.display = 'block';
                                                    (e.currentTarget.previousElementSibling as HTMLElement)!.style.display = 'none';
                                                }}
                                                onError={(e) => {
                                                    e.currentTarget.style.display = 'none';
                                                    (e.currentTarget.previousElementSibling as HTMLElement)!.style.display = 'none';
                                                }}
                                                style={{ display: 'none' }}
                                            />
                                        </Box>
                                    </div>
                                </div>
                                
                                <br/>
                            </div>
                            <br/>
                    <br/>
                    </div>
                    {/* <div className="col-md-12 col-lg-4 sidebar">
                        <div className="sidebar-box">
                            <div className="bio text-center" >
                                <Box position="relative" style={{ textAlign: 'center' }} component="div">
                                    <Skeleton variant="circular" width={150} height={150} style={{ margin: '0 auto', display: 'block' }} id="skeleton-loader" />
                                    <img
                                        src="./images/authors/sundarananda.jpg"
                                        alt="Image Placeholder"
                                        className="img-fluid mb-3"
                                        onLoad={(e) => {
                                            e.currentTarget.style.display = 'block';
                                            document.getElementById('skeleton-loader')!.style.display = 'none';
                                        }}
                                        onError={(e) => {
                                            e.currentTarget.style.display = 'none';
                                            document.getElementById('skeleton-loader')!.style.display = 'none';
                                        }}
                                        style={{ display: 'none', borderRadius: '50%', margin: '0 auto' }}
                                    />
                                </Box>
                                <div className="bio-body">
                                    <h6><i>autor članka:</i></h6>
                                    <h6><b>Tomislav Klasnić (Sundarananda das)</b></h6>
                                    <h6></h6>
                                    <p>Rođen je u Lipiku 1970 godine. Odrasta uz Novi Val i krajem svojeg srednjoškolskog obrazovanja postavlja si pitanja o smislu postojanja. Kroz vegetarijanstvo i yogu započinje svoju potraga za istinom. <Link to="" onClick={handleExpandClick}>više...</Link></p>
                                    
                                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                                    <p>Na studiju geodezije rasplamsava se njegova ljubav prema Vedskom znanju i prakticiranju Bhakti yoge, koju nastavlja prakticirati i danas. Odluka o posvećenom proučavanju duhovne poruke Bhakti yoge dovodi ga u ašram, školu cjeloživotnog duhovnog obrazovanja. 1990 godine susreće se sa svojim Guruom, te kasnije dobiva incijaciju u Bhakti tradiciji Vedske škole duhovnog znanja. U Indiju, koljevku zanja o yogi, otputovao je već više od 15-ak puta. Deset godina je služio kao misionar a 15 godina kao voditelj ašrama. Osnivač je i predsjednik udruge Centar za Vedske studije. Organizator je i suorganizator brojnih duhovnih retrita, mantra meditacija, Kirtan festivala (koncerti duhovne glazbe) u Lisinskom, HNK-u i Bogaloo-u. Osnivač je projekata Bhakti Yoga Centar na <Link to="https://www.facebook.com/BYCZagreb/">FaceBooku</Link> te na <Link to="https://www.youtube.com/channel/UCZwJF4Ip3nS7dn25G2WvI7A">YouTubeu</Link>. Osnivač je i voditelj projekta <Link to="https://www.facebook.com/SoulFoodHr">Soul food</Link> (hrana za dušu, klupski zdravljak). Proučavatelj je i predavač Vedske filozofije u Bhakti yoga tradiciji duhovnog znanja Veda. Vrtlar organskog povrća i voća. Doživotni učenik kulture nesebičnosti.</p>
                                    </Collapse>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    </div>
                </div>
            </section>
        </>
    );
}

export default SoulFoodPage;
